<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App',
    // metaInfo: {
    //   title: 'Manchester Dialect Map',
    // }
  }
</script>

<style>


@font-face {
  font-family: "OpenSans_Bold";
  src: url("assets/font/OpenSans-Bold_0.ttf");
}

@font-face {
  font-family: "OpenSans_Regular";
  src: url("assets/font/OpenSans-Regular_0.ttf");
}


body,html{
    height: 100%;
}

html{
  background:rgba(77,188,168,1);
    /* width: 100%; */
  height: 100%;
    /* min-height: 100%; */
}

body{
  /* width: 100%; */
  /* min-height: 100vh; */
  /* background: linear-gradient(0deg, rgba(145,204,143,1) 0%, rgba(77,188,168,1) 100%); */
  background: linear-gradient(0deg, rgba(77,188,168,1) 0%, rgba(145,204,143,1) 100%) no-repeat;
}
#app {
  font-family: "OpenSans_Regular", Arial, Helvetica, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
